/**
 * D454: the one-time note above the Almanac's branches for a world that was open before the
 * tree. The world carries `permanent.treeNote`; closing the note is remembered per world on this
 * device, in localStorage, every access in try/catch (storage can be missing or blocked).
 */
const KEY = 'hedgerow-tree-note-seen';

const keyOf = (worldId: string | null): string => (worldId ? `${KEY}-${worldId}` : KEY);

/** True once the note has been closed for this world on this device. */
export function treeNoteSeen(worldId: string | null): boolean {
  try {
    return globalThis.localStorage?.getItem(keyOf(worldId)) === '1';
  } catch {
    return false;
  }
}

export function markTreeNoteSeen(worldId: string | null): void {
  try {
    globalThis.localStorage?.setItem(keyOf(worldId), '1');
  } catch {
    // Kept for this visit only: the note shows once more on the next.
  }
}
